import { MenuItem } from '@material-ui/core'
import { authSelectors } from 'ducks/auth'
import { featuresActions } from 'ducks/features'
import { Badge, styled } from 'opensolar-ui'
import { ReactComponentLike } from 'prop-types'
import { useTranslate } from 'ra-core'
import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFeatureFlagStructsWithState } from 'util/featureFlags'

type Props = {
  className?: string
  onClick?: () => void
  MenuItemComponent?: ReactComponentLike
}

const StyledBadge = styled(Badge)({
  marginLeft: 8,
})

const StandardStates = ['enabled_user_optout', 'disabled_user_optin', 'disabled_user_apply']
const AdminStates = ['enabled_org_optout', 'disabled_org_optin', 'disabled_org_apply']

export const useHasBetaFeatures = () => {
  const { states } = useFeatureFlagStructsWithState()
  const isAdmin = useSelector(authSelectors.getIsAdmin)
  let hasAnyFeatures = useMemo(() => {
    const allStates = isAdmin ? [...StandardStates, ...AdminStates] : StandardStates
    return allStates.some((state) => states[state]?.length > 0)
  }, [states, isAdmin])
  return { hasAnyFeatures, states }
}

export const FeatureSettingsButton = ({ className, onClick, MenuItemComponent = MenuItem }: Props) => {
  const translate = useTranslate()
  const { hasAnyFeatures, states } = useHasBetaFeatures()
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(featuresActions.setFeaturesDialogOpen(true))
    if (onClick) onClick()
  }

  return (
    <>
      {hasAnyFeatures && (
        <>
          <MenuItemComponent className={className} onClick={handleClick}>
            {translate('Beta Features')}
            {/*
              Always show blue 'Beta Features' dot, will be made dynamic in the future
              See: https://github.com/open-solar/opensolar-todo/issues/20284
            */}
            <StyledBadge variant="dot" color="info" id="beta-features-menu-item-badge" />
          </MenuItemComponent>
        </>
      )}
    </>
  )
}
